// extracted by mini-css-extract-plugin
export default {"mainContainer":"CompanyRooms_mainContainer__SyHFC","headerContainer":"CompanyRooms_headerContainer__6Pd1f","errorMessage":"CompanyRooms_errorMessage__LzLOD"};